// @flow

import React from 'react';

import './Project.css';

/* PROJECT TEMPLATE
{
  'Title': '',           // required
  'img': '',             // required
  'Date': '',            // required
  'Reason': '',          // required
  'Course': '',          // optional
  'Languages': '',       // optional
  'Link': ['', ''],      // optional
  'Summary': ''          // required
}
*/

export type ProjectProps = {
  title: string,
  img: Object,
  date: string,
  reason: string,
  course?: string,
  languages?: string,
  link?: Array,
  summary: string,
};

export const Project = (props: ProjectProps) => {

  const course = props.course
    ? <p><u>Course</u>: {props.course}</p>
    : null;

  const languages = props.languages
    ? <p><u>Main languages</u>: {props.languages}</p>
    : null;

  const link = props.link
    ? <p><a href={props.link[1]}>{props.link[0]}</a></p>
    : null;

  return(
    <div className="project">
      <img className="proj-image" src={props.img} />
      <div className="proj-description">
        <p className="title"><b>{props.title}</b></p>
        <p><u>Date</u>: {props.date}</p>
        <p><u>Uni or leisure</u>: {props.reason}</p>
        {course}
        {languages}
        {link}
        <p className="summary">{props.summary}</p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/ProjectsPage/Project.js